import { Button } from '@codegouvfr/react-dsfr/Button';
import { FrServerIcon } from '@common/error';
import { useOauth2Actions } from '@common/oauth2';
import React from 'react';

export const AccesRefuse = ({ titleMessage, subMessage, isFc }: AccesRefuseProps) => {
  const { logout, logoutWithRedirect } = useOauth2Actions();

  const handleRetry = () => window.location.href = '/';

  return (
    <div className="min-h-screen p-4 flex h-screen" style={{ height: '100vh' }}>

      <div className="flex flex-col w-full">
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <div>
            <Button
              type="button"
              priority="secondary"
              iconId={'fr-icon-account-circle-fill'}
              onClick={() => (isFc) ? logout() : logoutWithRedirect()}>Se déconnecter
            </Button>
          </div>
        </div>

        <div className="fr-grid-row fr-grid-row--center fr-grid-row--gutters w-full justify-center"
             style={{ margin: 'auto' }}>

          <div className="fr-server__body fr-col-12 fr-col-md-6 text-center">

            <h1 className="fr-h1">{titleMessage}</h1>

            {(subMessage) && (
              <p className="fr-text--xl">subMessage</p>
            )}

            <Button priority="tertiary" onClick={handleRetry}>Réessayer</Button>
          </div>
          <FrServerIcon />
        </div>
      </div>
    </div>
  );
};

interface AccesRefuseProps {
  titleMessage: string;
  subMessage?: string;
  isFc?: boolean;
}
